// js/core/webPush.js — Abonnement Web Push (notifications téléphone/PWA hors-ligne)
//
// Appelé après que Notification.permission === 'granted'.
// Récupère la clé VAPID publique, souscrit au PushManager, envoie l'abonnement
// au serveur. Idempotent : si déjà abonné sur cet appareil, ne fait rien.

import { state } from './state.js';

let _subscribed = false;

// Convertit la clé VAPID base64url en Uint8Array (requis par PushManager)
function _urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function initWebPush() {
    if (_subscribed) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    if (!state.monPseudo) return;

    try {
        const reg = await navigator.serviceWorker.ready;

        // Vérifier si déjà abonné
        const existing = await reg.pushManager.getSubscription();
        if (existing) {
            _subscribed = true;
            // S'assurer que le serveur a bien cet abonnement (synchro après réinstall)
            await _sendToServer(existing);
            return;
        }

        // Récupérer la clé publique VAPID
        const resp = await fetch('/api/push/vapid-public-key');
        if (!resp.ok) return;
        const { key } = await resp.json();

        const subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: _urlBase64ToUint8Array(key)
        });

        await _sendToServer(subscription);
        _subscribed = true;
    } catch (e) {
        // Silencieux : certains navigateurs bloquent en contexte non-sécurisé
    }
}

async function _sendToServer(subscription) {
    try {
        await fetch('/api/push/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pseudo: state.monPseudo, subscription: subscription.toJSON() })
        });
    } catch (_) {}
}

export async function unsubscribeWebPush() {
    if (!('serviceWorker' in navigator)) return;
    try {
        const reg = await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        if (!sub) return;
        await fetch('/api/push/subscribe', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pseudo: state.monPseudo, endpoint: sub.endpoint })
        });
        await sub.unsubscribe();
        _subscribed = false;
    } catch (_) {}
}
